import React, { useState } from "react";
import "./Social.css";
import { IoMdClose } from "react-icons/io";

export default function PricingPlans() {
  const [activeTab, setActiveTab] = useState("monthly"); // monthly | quarterly | halfyear | yearly
  const [selectedPlan, setSelectedPlan] = useState(null);

  // Shared full details (same across durations)
  const fullDetails = {
    resources: [
      { label: "Dedicated Resources", value: "" }, // values updated per plan below
    ],
    setup: [
      "WhatsApp Group Creation - Team Collaboration ✔",
      "0 Day Report for MOM Growth Comparison ✔",
      "Google Analytics - Setup and Review ✔",
      "Google Search Console - Setup and Review ✔",
      "Google Penalty Check ✔",
      "Website Indexing Check ✔",
      "Business Brief Meeting ✔",
      "Sitemap Submission ✔"
    ],
    onpage_seo: [],
    offpage_seo: [],
    technical_seo: [],
    reporting: [],
    support: []
  };

  // Build full details per plan (from screenshots)
  const planDetails = {
    lite: {
      resources: [
        { label: "Dedicated Resources", value: "1" },
        { label: "SM Executive", value: "1" },
        { label: "Asst. SM Executive", value: "❌" },
        { label: "Shared Resources", value: "2" },
        { label: "SM Manager", value: "❌" },
        { label: "Graphic Designer", value: "1" },
        { label: "Copy Writer", value: "1" }
      ],

      initial_setup_and_strategy: [
        { label: "WhatsApp Group Creation - Team Collabration", value: "✔" },
        { label: "0 Day Report for MOM Growth Comparison", value: "✔" },
        { label: "Business Brief Meeting", value: "✔" },
        { label: "Account Creation/Overhaul", value: "✔" },
        { label: "Audience Research", value: "Basic" },
        { label: "Campaign Strategy Development", value: "Basic" }
      ],

      ad_creation_and_optimization: [
        { label: "Ad Plateforms Included", value: "FB, Insta or LinkedIn" },
        { label: "Ad Campaigns / Plateform", value: "3" },
        { label: "Ad Designs", value: "6 Ads" },
        { label: "Ad Copywriting", value: "6 Ads" },
        { label: "Creative Refresh", value: "Quarterly" },
        { label: "A/B Testing", value: "❌" },
        { label: "Dynamic Creative Optimization", value: "❌" },
        { label: "Carousel Ads", value: "❌" },
        { label: "Video Ads", value: "❌" }
      ],

      targeting_and_retargting: [
        { label: "Geographic Targeting", value: "✔" },
        { label: "Demographic Targeting", value: "✔" },
        { label: "Interest-Based Targeting", value: "✔" },
        { label: "Behavioral Targeting", value: "✔" },
        { label: "Retargeting Campaign Setup", value: "✔" },
        { label: "Lookalike Audiences", value: "✔" },
        { label: "Budget Management", value: "✔" },
        { label: "Budget Allocation", value: "✔" },
        { label: "CPC Optimization", value: "❌" },
        { label: "CPA Optimization", value: "❌" }
      ],

      analytics_and_reporting: [
        { label: "Planning", value: "Basic" },
        { label: "Strategy", value: "Basic" },
        { label: "Real-Time Monitoring", value: "❌" },
        { label: "Weekly Performance Reports", value: "❌" },
        { label: "In-depth Monthly Reports", value: "✔" },
        { label: "Conversion Tracking", value: "Basic" },
        { label: "ROAS Analysis", value: "✔" },
        { label: "Daily Updates in Group", value: "❌" }
      ],

      support_and_consultation: [
        { label: "Phone Support", value: "✔" },
        { label: "Chat Support", value: "✔" },
        { label: "Email Support", value: "✔" },
        { label: "Monthly Consultation", value: "1 hour" },
        { label: "PRP (Performance Review & Planning)", value: "Monthly" }
      ]
    },

    standard: {
      resources: [
        { label: "Dedicated Resources", value: "2" },
        { label: "SM Executive", value: "1" },
        { label: "Asst. SM Executive", value: "1" },
        { label: "Shared Resources", value: "2" },
        { label: "SM Manager", value: "❌" },
        { label: "Graphic Designer", value: "1" },
        { label: "Copy Writer", value: "1" }
      ],

      initial_setup_and_strategy: [
        { label: "WhatsApp Group Creation - Team Collabration", value: "✔" },
        { label: "0 Day Report for MOM Growth Comparison", value: "✔" },
        { label: "Business Brief Meeting", value: "✔" },
        { label: "Account Creation/Overhaul", value: "✔" },
        { label: "Audience Research", value: "Advanced" },
        { label: "Campaign Strategy Development", value: "Advanced" }
      ],

      ad_creation_and_optimization: [
        { label: "Ad Plateforms Included", value: "FB, Insta or LinkedIn" },
        { label: "Ad Campaigns / Plateform", value: "4" },
        { label: "Ad Designs", value: "8 Ads" },
        { label: "Ad Copywriting", value: "8 Ads" },
        { label: "Creative Refresh", value: "Quarterly" },
        { label: "A/B Testing", value: "❌" },
        { label: "Dynamic Creative Optimization", value: "❌" },
        { label: "Carousel Ads", value: "✔" },
        { label: "Video Ads", value: "❌" }
      ],

      targeting_and_retargting: [
        { label: "Geographic Targeting", value: "✔" },
        { label: "Demographic Targeting", value: "✔" },
        { label: "Interest-Based Targeting", value: "✔" },
        { label: "Behavioral Targeting", value: "✔" },
        { label: "Retargeting Campaign Setup", value: "✔" },
        { label: "Lookalike Audiences", value: "✔" },
        { label: "Budget Management", value: "✔" },
        { label: "Budget Allocation", value: "✔" },
        { label: "CPC Optimization", value: "✔" },
        { label: "CPA Optimization", value: "✔" }
      ],

      analytics_and_reporting: [
        { label: "Planning", value: "Intermediate" },
        { label: "Strategy", value: "Intermediate" },
        { label: "Real-Time Monitoring", value: "✔" },
        { label: "Weekly Performance Reports", value: "❌" },
        { label: "In-depth Monthly Reports", value: "✔" },
        { label: "Conversion Tracking", value: "Advanced" },
        { label: "ROAS Analysis", value: "✔" },
        { label: "Daily Updates in Group", value: "❌" }
      ],

      support_and_consultation: [
        { label: "Phone Support", value: "✔" },
        { label: "Chat Support", value: "✔" },
        { label: "Email Support", value: "✔" },
        { label: "Monthly Consultation", value: "2 hours" },
        { label: "PRP (Performance Review & Planning)", value: "Monthly" }
      ]
    },

    advance: {
      resources: [
        { label: "Dedicated Resources", value: "2" },
        { label: "SM Executive", value: "1" },
        { label: "Asst. SM Executive", value: "1" },
        { label: "Shared Resources", value: "3" },
        { label: "SM Manager", value: "1" },
        { label: "Graphic Designer", value: "1" },
        { label: "Copy Writer", value: "1" }
      ],

      initial_setup_and_strategy: [
        { label: "WhatsApp Group Creation - Team Collabration", value: "✔" },
        { label: "0 Day Report for MOM Growth Comparison", value: "✔" },
        { label: "Business Brief Meeting", value: "✔" },
        { label: "Account Creation/Overhaul", value: "✔" },
        { label: "Audience Research", value: "Comprehensive" },
        { label: "Campaign Strategy Development", value: "Comprehensive" }
      ],

      ad_creation_and_optimization: [
        { label: "Ad Plateforms Included", value: "FB, Insta & LinkedIn" },
        { label: "Ad Campaigns / Plateform", value: "6" },
        { label: "Ad Designs", value: "12 Ads" },
        { label: "Ad Copywriting", value: "12 Ads" },
        { label: "Creative Refresh", value: "Monthly" },
        { label: "A/B Testing", value: "✔" },
        { label: "Dynamic Creative Optimization", value: "✔" },
        { label: "Carousel Ads", value: "✔" },
        { label: "Video Ads", value: "✔" }
      ],

      targeting_and_retargting: [
        { label: "Geographic Targeting", value: "✔" },
        { label: "Demographic Targeting", value: "✔" },
        { label: "Interest-Based Targeting", value: "✔" },
        { label: "Behavioral Targeting", value: "✔" },
        { label: "Retargeting Campaign Setup", value: "✔" },
        { label: "Lookalike Audiences", value: "✔" },
        { label: "Budget Management", value: "✔" },
        { label: "Budget Allocation", value: "✔" },
        { label: "CPC Optimization", value: "✔" },
        { label: "CPA Optimization", value: "✔" }
      ],

      analytics_and_reporting: [
        { label: "Planning", value: "Advanced" },
        { label: "Strategy", value: "Advanced" },
        { label: "Real-Time Monitoring", value: "✔" },
        { label: "Weekly Performance Reports", value: "❌" },
        { label: "In-depth Monthly Reports", value: "✔" },
        { label: "Conversion Tracking", value: "Comprehensive" },
        { label: "ROAS Analysis", value: "✔" },
        { label: "Daily Updates in Group", value: "✔" }
      ],

      support_and_consultation: [
        { label: "Phone Support", value: "✔" },
        { label: "Chat Support", value: "✔" },
        { label: "Email Support", value: "✔" },
        { label: "Monthly Consultation", value: "4 hours" },
        { label: "PRP (Performance Review & Planning)", value: "Monthly" }
      ]
    },

    enterprise: {
      resources: [
        { label: "Dedicated Resources", value: "2" },
        { label: "SM Executive", value: "1" },
        { label: "Asst. SM Executive", value: "1" },
        { label: "Shared Resources", value: "3" },
        { label: "SM Manager", value: "1" },
        { label: "Graphic Designer", value: "1" },
        { label: "Copy Writer", value: "1" }
      ],

      initial_setup_and_strategy: [
        { label: "WhatsApp Group Creation - Team Collabration", value: "✔" },
        { label: "0 Day Report for MOM Growth Comparison", value: "✔" },
        { label: "Business Brief Meeting", value: "✔" },
        { label: "Account Creation/Overhaul", value: "✔" },
        { label: "Audience Research", value: "In-depth" },
        { label: "Campaign Strategy Development", value: "Customized" }
      ],

      ad_creation_and_optimization: [
        { label: "Ad Plateforms Included", value: "FB, Insta, LinkedIn & YouTube" },
        { label: "Ad Campaigns / Plateform", value: "Unlimited" },
        { label: "Ad Designs", value: "20+ Ads" },
        { label: "Ad Copywriting", value: "20+ Ads" },
        { label: "Creative Refresh", value: "As Needed" },
        { label: "A/B Testing", value: "✔" },
        { label: "Dynamic Creative Optimization", value: "✔" },
        { label: "Carousel Ads", value: "✔" },
        { label: "Video Ads", value: "✔" }
      ],

      targeting_and_retargting: [
        { label: "Geographic Targeting", value: "✔" },
        { label: "Demographic Targeting", value: "✔" },
        { label: "Interest-Based Targeting", value: "✔" },
        { label: "Behavioral Targeting", value: "✔" },
        { label: "Retargeting Campaign Setup", value: "✔" },
        { label: "Lookalike Audiences", value: "✔" },
        { label: "Budget Management", value: "✔" },
        { label: "Budget Allocation", value: "✔" },
        { label: "CPC Optimization", value: "✔" },
        { label: "CPA Optimization", value: "✔" }
      ],

      analytics_and_reporting: [
        { label: "Planning", value: "Comprehensive" },
        { label: "Strategy", value: "Comprehensive" },
        { label: "Real-Time Monitoring", value: "✔" },
        { label: "Weekly Performance Reports", value: "✔" },
        { label: "In-depth Monthly Reports", value: "Custom Reports" },
        { label: "Conversion Tracking", value: "Comprehensive" },
        { label: "ROAS Analysis", value: "Customized" },
        { label: "Daily Updates in Group", value: "✔" }
      ],

      support_and_consultation: [
        { label: "Phone Support", value: "✔" },
        { label: "Chat Support", value: "✔" },
        { label: "Email Support", value: "✔" },
        { label: "Monthly Consultation", value: "8 hours" },
        { label: "PRP (Performance Review & Planning)", value: "Monthly" }
      ]
    }

  };

  // Price table for each duration (from your screenshots / confirmed)
  const priceTable = {
    monthly: {
      lite: "₹20,000",
      standard: "₹35,000",
      advance: "₹50,000",
      enterprise: "₹150,000"
    },
    quarterly: {
      lite: "₹18,000",
      standard: "₹31,500",
      advance: "₹45,000",
      enterprise: "₹135,000"
    },
    halfyear: {
      lite: "₹16,000",
      standard: "₹28,000",
      advance: "₹40,000",
      enterprise: "₹120,000"
    },
    yearly: {
      lite: "₹14,000",
      standard: "₹24,500",
      advance: "₹35,000",
      enterprise: "₹105,000"
    }
  };

  // Build plans array from priceTable for the active tab
  const planMeta = [
    { id: "lite", title: "LITE", type: "Small Business" },
    { id: "standard", title: "STANDARD", type: "Moderate Competition" },
    { id: "advance", title: "ADVANCE", type: "Ecommerce / High Competition" },
    { id: "enterprise", title: "ENTERPRISE", type: "Brands / High Competition" }
  ];

  const plans = planMeta.map(p => ({
    id: p.id,
    title: p.title,
    price: priceTable[activeTab][p.id],
    type: p.type,
    features: (() => {
      if (p.id === "lite") return [
        "Dedicated SM Executive, Shared Graphic Designer, Copy writer",
        "Basic Audience research & Campaign Strategy development",
        "6 Ad designs & copywriting & 3 campaigns, Quarterly creative refrences",
        "Basic Strategy planning and conversion tracking",
        "1-hour monthly consultation and PRP"
      ];
      if (p.id === "standard") return [
        "Dedicated SM Executive & Assistant, Shared Graphic Designer, Copy...",
        "Advanced Audience research & Campaign Strategy development ",
        "8 Ad designs & copywriting & 4 campaigns, Quarterly creative refr...",
        "Intermediate Strategy planning & advanced conversion tracking",
        "2 hours monthly consultation and PRP"
      ];
      if (p.id === "advance") return [
        "Dedicated SM Executive & Assistant, Shared SM Manager, Graphic De...",
        "Comprehensive Audience research & Campaign Strategy development",
        "12 Ad designs & copywriting & 6 campaigns, Monthly creative refre...",
        "Advanced Strategy planning & comprehensive conversion tracking",
        "4 hours monthly consultation and PRP"
      ];
      return [
        "Dedicated SM Executive & Assistant, Shared SM Manager, Graphic De...",
        "In-depth Audience research & Customized Campaign Strategy",
        "20+ Ad designs & copywriting on 4 platforms, creative refresh as...",
        "Comprehensive Strategy planning & conversion tracking",
        "8 hours monthly consultation and PRP"
      ];
    })(),
    details: planDetails[p.id]
  }));

  return (
    <div className="pricing-wrapper">
      <section className="price-header" />
      <section className="about-header">
        <div className="photo-text">Social Media Ads
          <p>
            Packages & Plans
          </p>
        </div>
      </section>

      <div className="tabs">
        {[
          { id: "monthly", label: <>Month <br /> (1 Month)</> },
          { id: "quarterly", label: <>Quarterly <br /> (3 Months)</> },
          { id: "halfyear", label: <>Half Yearly <br /> (6 Months)</> },
          { id: "yearly", label: <>Yearly <br /> (12 Months)</> },
        ].map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`tab-btn ${activeTab === tab.id ? "active" : ""}`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="plans-grid">
        {plans.map(plan => (
          <div key={plan.id} className="plan-card">
            {/* POPULAR TAG */}
            {plan.id === "standard" && <div className="popular-tag">Popular</div>}

            {/* DISCOUNT + PRICE */}
            <h3 className="plan-title">{plan.title}</h3>

            <div className="price-section">
              {/* Show original price & discount only if NOT monthly */}
              {activeTab !== "monthly" && (
                <>
                  <p className="original-price">
                    ₹{(() => {
                      const monthlyPrices = {
                        lite: 20000,
                        standard: 35000,
                        advance: 50000,
                        enterprise: 150000
                      };

                      // Multiplying months so original price = base × months
                      const multipliers = {
                        quarterly: 1,
                        halfyear: 1,
                        yearly: 1
                      };

                      return (monthlyPrices[plan.id] * multipliers[activeTab]).toLocaleString();
                    })()}
                  </p>

                  {/* Dynamic discount badge */}
                  <span className="discount-badge">
                    {activeTab === "quarterly" && "10% Off"}
                    {activeTab === "halfyear" && "20% Off"}
                    {activeTab === "yearly" && "30% Off"}
                  </span>
                </>
              )}
            </div>


            <h2 className="plan-price">{plan.price}</h2>
            <p className="per-month">/Month</p>



            <button className="quote-btn">Get Quote</button>

            <hr className="divider" />
            <p className="plan-type">{plan.type}</p>

            <ul className="feature-list">
              {plan.features.map((f, idx) => (
                <li key={idx}>{f}</li>
              ))}
            </ul>

            <button className="details-btn" onClick={() => setSelectedPlan(plan)}>
              <span className="details-btn-txt">View Details</span>
            </button>
          </div>

        ))}
      </div>

      {selectedPlan && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="popup-header">
              <h2 className="popup-title">{selectedPlan.title}</h2>
              <button className="close-btn" onClick={() => setSelectedPlan(null)}><IoMdClose /></button>
            </div>

            <div className="popup-grid">
              {/* Resources */}
              <div className="card">
                <h3 className="popup-subtitle">Resources</h3>
                <ul>
                  {selectedPlan?.details?.resources?.map((r, i) => (
                    <li key={i}>
                      <span className="left">{r.label}</span>
                      <span className="sep">:</span>
                      <span className="right">{r.value}</span>
                    </li>
                  )) || null}
                </ul>
              </div>

              {/* Initial Setup & Strategy */}
              <div className="card">
                <h3 className="popup-subtitle">Initial Setup & Strategy</h3>
                <ul>
                  {selectedPlan?.details?.initial_setup_and_strategy?.map((s, i) => (
                    <li key={i}>
                      <span className="left">{s.label}</span>
                      <span className="sep">:</span>
                      <span className="right">{s.value}</span>
                    </li>
                  )) || null}
                </ul>
              </div>

              {/* Ad Creation & Optimization */}
              <div className="card">
                <h3 className="popup-subtitle">Ad Creation & Optimization</h3>
                <ul>
                  {selectedPlan?.details?.ad_creation_and_optimization?.map((s, i) => (
                    <li key={i}>
                      <span className="left">{s.label}</span>
                      <span className="sep">:</span>
                      <span className="right">{s.value}</span>
                    </li>
                  )) || null}
                </ul>
              </div>

              {/* Targeting & Retargeting */}
              <div className="card">
                <h3 className="popup-subtitle">Targeting & Retargeting</h3>
                <ul>
                  {selectedPlan?.details?.targeting_and_retargting?.map((s, i) => (
                    <li key={i}>
                      <span className="left">{s.label}</span>
                      <span className="sep">:</span>
                      <span className="right">{s.value}</span>
                    </li>
                  )) || null}
                </ul>
              </div>

              {/* Analytics & Reporting */}
              <div className="card">
                <h3 className="popup-subtitle">Analytics & Reporting</h3>
                <ul>
                  {selectedPlan?.details?.analytics_and_reporting?.map((s, i) => (
                    <li key={i}>
                      <span className="left">{s.label}</span>
                      <span className="sep">:</span>
                      <span className="right">{s.value}</span>
                    </li>
                  )) || null}
                </ul>
              </div>

              {/* Support & Consultation */}
              {selectedPlan?.details?.support_and_consultation?.length > 0 && (
                <div className="card">
                  <h3 className="popup-subtitle">Support & Consultation</h3>
                  <ul>
                    {selectedPlan.details.support_and_consultation.map((s, i) => (
                      <li key={i}>
                        <span className="left">{s.label}</span>
                        <span className="sep">:</span>
                        <span className="right">{s.value}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>


            <a
              href={`https://wa.me/919624883636?text=${encodeURIComponent(
                `Hi! I'm interested in the ${selectedPlan.title} plan (${activeTab.toUpperCase()}). Please share more details.`
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              className="subscribe-btn"
            >
              Subscribe Now
            </a>

          </div>
        </div>
      )}
    </div>
  );
}
